import React, {useState} from 'react';
import api from 'controllers/raymanAPI.js';
import settings from 'controllers/settings';
import { Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import {TextField, PasswordField, Button, Text, Link} from 'components/core';


function Login( { onUserLogged = () => {} } )
{
    const [username, updateUsername] = useState("");
    const [password, updatePassword] = useState("");
    const [errorText, updateErrorText] = useState("");

    async function doLogin()
    {
        let tmpUser = username;
        let tmpPass = password;
        let loginResponse = await api.authentication.postLogin({user: tmpUser, password: tmpPass});
        if(!loginResponse) updateErrorText("Usuario o contraseña incorrectos");
        else
        {
            onUserLogged(loginResponse);
        }
    }

    function keyPress(evt)
    {
        if(evt.charCode === 13)
        {
            doLogin();
        }
    }
    return (
        <Grid onKeyPress={keyPress}
        container
        direction="column"
        justify="center"
        alignItems="stretch"
        spacing={2}
        >
            <Grid item>
            <Text title>Iniciar sesión</Text>
            </Grid>
            { errorText !== "" ? 
            <Grid item>
                <Alert severity="error" onDismiss={() => updateErrorText("")} dismissButtonAriaLabel="Close">
                    {errorText}
                </Alert>
            </Grid>
            : ""
            }
            <Grid item>
                <TextField label="Email" placeholder="user@example.com" onChange={ (evt) => updateUsername(evt.target.value)}/>
            </Grid>
            <Grid item>
                <PasswordField label="Contraseña" onChange={ (evt) => updatePassword(evt.target.value)}/>
            </Grid>
            <Grid item className="passwordLink">
                {settings.server === "production" ? <Link to="/reset-password">Recordar contraseña</Link> : ""}
            </Grid>
            <Grid item>
                <Button onClick={doLogin}>Acceder</Button>
            </Grid>
        </Grid>
    );    
}

    

export default Login;
    